import React from "react";

export default function TutorialSkeleton() {
  return (
    <div className="space-y-6">
      <div className="h-[360px] animate-pulse rounded-[30px] bg-slate-800" />

      <div className="h-24 animate-pulse rounded-[26px] bg-slate-200 dark:bg-slate-800" />

      <div className="grid gap-6 lg:grid-cols-[280px_minmax(0,1fr)]">
        <div className="hidden h-[420px] animate-pulse rounded-[26px] bg-slate-200 dark:bg-slate-800 lg:block" />

        <div className="space-y-4">
          {Array.from({
            length: 4,
          }).map((_, index) => (
            <div
              key={index}
              className="h-32 animate-pulse rounded-[24px] bg-slate-200 dark:bg-slate-800"
            />
          ))}
        </div>
      </div>
    </div>
  );
}